import { getAuthHeaders, getBaseUrl } from './apiClient';

export type BlogStage = {
  stage_id: string;
  name?: string;
  description?: string;
  order?: number | null;
  prompt_ids?: string[];
  depends_on?: string[];
  requires_human?: boolean;
  prompt_template?: string;
  system_prompt?: string | null;
  model?: string;
  temperature?: number | null;
  max_tokens?: number | null;
  thinking?: { type: 'adaptive' | 'enabled'; budget_tokens?: number } | null;
  effort?: 'low' | 'medium' | 'high' | null;
  type?: string;
  status: 'active' | 'archived';
  createdAt: string;
  updatedAt: string;
  createdBy?: string;
  version?: number;
};

export const blogStagesService = {
  async list(status?: 'active' | 'archived'): Promise<{ stages: BlogStage[]; count: number }> {
    const qs = status ? `?status=${encodeURIComponent(status)}` : '';
    const resp = await fetch(`${getBaseUrl()}/secure/blog/stages${qs}`, { headers: await getAuthHeaders() });
    if (!resp.ok) throw new Error(`Failed to list stages (${resp.status})`);
    return await resp.json();
  },
  async get(stageId: string): Promise<BlogStage> {
    const resp = await fetch(`${getBaseUrl()}/secure/blog/stages/${encodeURIComponent(stageId)}`, { headers: await getAuthHeaders() });
    if (!resp.ok) throw new Error(`Failed to get stage (${resp.status})`);
    return await resp.json();
  },
  async create(payload: Partial<BlogStage> & { stage_id: string }): Promise<BlogStage> {
    const resp = await fetch(`${getBaseUrl()}/secure/blog/stages`, {
      method: 'POST',
      headers: await getAuthHeaders(),
      body: JSON.stringify(payload)
    });
    if (!resp.ok) {
      const text = await resp.text();
      throw new Error(`Failed to create stage: ${resp.status} ${text}`);
    }
    return await resp.json();
  },
  async update(stageId: string, payload: Partial<BlogStage>): Promise<BlogStage> {
    const resp = await fetch(`${getBaseUrl()}/secure/blog/stages/${encodeURIComponent(stageId)}`, {
      method: 'PUT',
      headers: await getAuthHeaders(),
      body: JSON.stringify(payload)
    });
    if (!resp.ok) {
      const text = await resp.text();
      throw new Error(`Failed to update stage: ${resp.status} ${text}`);
    }
    return await resp.json();
  }
};
